import { forwardRef } from 'react'
import { FieldValidator } from 'final-form'
import { useField, useForm } from 'react-final-form'
import { ChipGroup, Props as ChipGroupProps } from './ChipGroup'

type Props = {
  name: string
  validate?: FieldValidator<string | string[]>
  onChange?: (value: string) => void
} & Pick<ChipGroupProps, 'options' | 'label' | 'isMultiSelect'>

export const ChipGroupField = forwardRef(({ name, validate, options, label, isMultiSelect }: Props, ref) => {
  const form = useForm()
  const { input, meta } = useField<string | string[]>(name, { validate })

  const errorMessage = meta.touched && (meta.error || meta.submitError)

  const handleChange = (value: string | string[]) => {
    form.change(name, value)
  }

  return (
    <ChipGroup
      ref={ref}
      options={options}
      value={input.value}
      label={label}
      error={errorMessage}
      isMultiSelect={isMultiSelect}
      onChange={handleChange}
    />
  )
})

ChipGroupField.displayName = 'ChipGroupField'
